import { render, staticRenderFns } from "./leaderboard-views-reach-card.vue?vue&type=template&id=08e3735c&scoped=true&"
import script from "./leaderboard-views-reach-card.vue?vue&type=script&lang=js&"
export * from "./leaderboard-views-reach-card.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard-views-reach-card.vue?vue&type=style&index=0&id=08e3735c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3735c",
  null
  
)

export default component.exports